module.exports = "/images/ddos.png?7c97ef562e96077d48425047e5f351cd";